import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { joinTo3lkanfaxbzac2 as joinTo } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  URLBuilder2mz8zkz4u9ray as URLBuilder,
  set_encodedPath3q0i8nsv3a7qy as set_encodedPath,
} from './URLBuilder.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from './URLParser.mjs';
import { parseQueryString1nwcni3n22i7m as parseQueryString } from './Query.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function takeFrom_0(_this__u8e3s4, url) {
  _this__u8e3s4.protocolOrNull_1 = url.protocolOrNull_1;
  _this__u8e3s4.host_1 = url.host_1;
  _this__u8e3s4.set_port_gcpocq_k$(url.port_1);
  _this__u8e3s4.encodedPathSegments_1 = url.encodedPathSegments_1;
  _this__u8e3s4.encodedUser_1 = url.encodedUser_1;
  _this__u8e3s4.encodedPassword_1 = url.encodedPassword_1;
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAll(this_0, url.encodedParameters_1);
  _this__u8e3s4.set_encodedParameters_t3ck1r_k$(this_0);
  _this__u8e3s4.encodedFragment_1 = url.encodedFragment_1;
  _this__u8e3s4.trailingQuery_1 = url.trailingQuery_1;
  return _this__u8e3s4;
}
function Url(urlString) {
  return URLBuilder_0(urlString).build_1k0s4u_k$();
}
function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(encodedPath)) {
    tmp = !startsWith(encodedPath, '/');
  } else {
    tmp = false;
  }
  if (tmp) {
    _this__u8e3s4.append_58al37_k$(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.append_jgojdo_k$(encodedPath);
  if (!encodedQueryParameters.isEmpty_y1axqb_k$() || trailingQuery) {
    _this__u8e3s4.append_jgojdo_k$('?');
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = encodedQueryParameters.entries_qbkxv4_k$();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var key = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var value = element.get_value_j01efc_k$();
    var tmp_0;
    if (value.isEmpty_y1axqb_k$()) {
      tmp_0 = listOf(to(key, null));
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(value, 10));
      var _iterator__ex2g4s_0 = value.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp$ret$8 = to(key, item);
        destination_0.add_utx5q5_k$(tmp$ret$8);
      }
      tmp_0 = destination_0;
    }
    var list = tmp_0;
    addAll(destination, list);
  }
  var tmp_1 = destination;
  joinTo(tmp_1, _this__u8e3s4, '&', VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
}
function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
  if (encodedUser == null) {
    return Unit_instance;
  }
  _this__u8e3s4.append_22ad7x_k$(encodedUser);
  if (!(encodedPassword == null)) {
    _this__u8e3s4.append_58al37_k$(_Char___init__impl__6a9atx(58));
    _this__u8e3s4.append_22ad7x_k$(encodedPassword);
  }
  _this__u8e3s4.append_22ad7x_k$('@');
}
function URLBuilder_0(urlString) {
  return takeFrom(new (URLBuilder())(), urlString);
}
function get_hostWithPortIfSpecified(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.specifiedPort_1;
  return tmp0_subject === 0 || tmp0_subject === _this__u8e3s4.protocol_1.defaultPort_1 ? _this__u8e3s4.host_1 : get_hostWithPort(_this__u8e3s4);
}
function get_hostWithPort(_this__u8e3s4) {
  return _this__u8e3s4.host_1 + ':' + _this__u8e3s4.get_port_wosj4a_k$();
}
function URLBuilder_1(url) {
  return takeFrom_1(new (URLBuilder())(), url);
}
function takeFrom_1(_this__u8e3s4, url) {
  _this__u8e3s4.protocolOrNull_1 = url.protocolOrNull_1;
  _this__u8e3s4.host_1 = url.host_1;
  _this__u8e3s4.set_port_gcpocq_k$(url.get_port_wosj4a_k$());
  set_encodedPath(_this__u8e3s4, url.get_encodedPath_p9zwnq_k$());
  _this__u8e3s4.encodedUser_1 = url.get_encodedUser_p9wcq8_k$();
  _this__u8e3s4.encodedPassword_1 = url.get_encodedPassword_rswp28_k$();
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  this_0.appendAll_k8dlt1_k$(parseQueryString(url.get_encodedQuery_28s95p_k$(), VOID, VOID, false));
  _this__u8e3s4.set_encodedParameters_t3ck1r_k$(this_0);
  _this__u8e3s4.encodedFragment_1 = url.get_encodedFragment_jm6jcb_k$();
  _this__u8e3s4.trailingQuery_1 = url.trailingQuery_1;
  return _this__u8e3s4;
}
function appendUrlFullPath$lambda(it) {
  var key = it.first_1;
  var tmp;
  if (it.second_1 == null) {
    tmp = key;
  } else {
    var value = toString(it.second_1);
    tmp = key + '=' + value;
  }
  return tmp;
}
//region block: exports
export {
  URLBuilder_0 as URLBuilder1nlnzfhn643pn,
  URLBuilder_1 as URLBuilder1hwx1b9569i61,
  Url as Urlowwyg1lanrqp,
  appendUrlFullPath as appendUrlFullPath2slafmfwiwvmw,
  appendUserAndPassword as appendUserAndPassword2m6va0hoftk5,
  get_hostWithPortIfSpecified as get_hostWithPortIfSpecified1w0e2oq2yfcan,
  takeFrom_1 as takeFrom2oawu6chjqyp9,
  takeFrom_0 as takeFromkqlcz7c6dx2r,
};
//endregion

//# sourceMappingURL=URLUtils.mjs.map
